import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

const Outer = props => {
  if (props.to) {
    return <RouterLink {...props} />;
  } else if (props.href) {
    return <a {...props}>{props.children}</a>;
  }

  return <button {...props} />;
};

const Base = styled(Outer)`
  &:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }
  font-family: 'GT-Walsheim', sans-serif;
  border: none;
  background: none;
  padding: 0;
  display: inline-block;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

export const ButtonBase = props => <Base {...props} />;

Outer.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.any
};

ButtonBase.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Button/ButtonBase.js